query allMarketCodes(
    $first: Int,
    $offset: Int,
    $filter: MarketCodeFilter
) {
  marketCodes: allMarketCodes(
    first: $first,
    offset: $offset,
    filter: $filter
) {
    nodes {
      code
    }
  }
}
